import React from 'react';
import { NavLink } from "react-router-dom";
import { routeService } from '../../../services/route.service';

interface LinksPreviewProps {
    readonly domName: string;
    readonly routeName: string;
    readonly queryParams?: URLSearchParams;
}

export function LinksPreview({ domName, routeName, queryParams }: LinksPreviewProps) {
    const path = queryParams
        ? `${routeService[routeName]}/?${queryParams.toString()}`
        : routeService[routeName];

    return (
        <NavLink
            to={path}
            className={({ isActive }) =>
                `text-base font-semibold transition-colors duration-200 ${isActive ? "text-[#C00035] border-b-2 border-[#C00035]" : "text-gray-500 hover:text-[#C00035]"
                }`
            }
        >
            {domName}
        </NavLink>
    );
}
